import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SucursalLocationService {


  // urlApi: string = 'https://rickandmortyapi.com/api/character/1,183';
  /*constructor(private http: HttpClient) {
  }

  public getData(): Observable<Object> {
    return this.http.get(this.urlApi);
  }*/



}
